export default "__VITE_ASSET__BVvq2PJl__"